/* eslint-disable */
import React from 'react';
import axios from 'axios'


import StudentServiceHome from '../Home/StudentServiceHome';
import ProfessorHome from '../Home/ProfessorHome';
import StudentHome from '../Home/StudentHome';
import HomePage from './HomePage';
import AssistantHome from "../Home/AssistantHome";
import PropertyHome from "../Home/PropertyHome";
import { ToastContainer } from 'react-toastify';
import DefaultHomePage from '../Home/DefaultHomePage';
import EmploymentServiceCSHome from '../EmploymentServiceCS/EmploymentServiceCSHome';


axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

class Dashboard extends React.Component {

  constructor(props) {
      super(props);
      this.state = {
          activeRole: '',
          academicYear:'',
      };
      this.props = props;
  }
  // secondLevelActive(routeName) {
  //   return this.this.props.location.pathname.indexOf(routeName) > -1 ? "nav nav-second-level collapse in" : "nav nav-second-level collapse";
  // }


  componentDidMount() {

      if(!localStorage.getItem('activeRole')){
          window.localStorage.clear();
  }
      else{
          let activeRole = localStorage.getItem('activeRole');
          window.localStorage.clear();
          this.getUserData()
          localStorage.setItem('activeRole', activeRole);
          axios.get('/academic-years/current').then(res => {
              this.setState({ academicYear: res.data});
              localStorage.setItem('academicYear', JSON.stringify(this.state.academicYear));
          })
              .catch(err => {
                  console.log('Failed to fetch academic year.');
              });
      }




}
    getUserData() {
        axios.all([this.fetchUserOrganizationalUnit()])
            .then(axios.spread((userOrganizationalUnitRes) => {
                const organizationalUnitId = userOrganizationalUnitRes.data;
                localStorage.setItem('organizationalUnitId', organizationalUnitId);
                this.setState({ organizationalUnitId });
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch data.');
            });
    }

    fetchUserOrganizationalUnit() {
        return axios.get('/user/organizational-unit');
    }


  render() {
      const { activeRole } = this.props;
    return (
      <div className="animated fadeIn">
      {activeRole.substr(0, 8) === 'Profesor' ?
          <ProfessorHome />
          : activeRole.substr(0, 8) === 'Asistent' ?
              <AssistantHome/>
      : activeRole.substr(0, 8) === 'Student:' ?
              <StudentHome />
              : activeRole.substr(0, 7) === 'Imovina' ?
                      <DefaultHomePage />
      : activeRole.substr(0, 13) === 'Administrator' ?
      <div>Početna strana za administratora</div>
      : activeRole.substr(0, 10) === 'Studentska' ?
      <StudentServiceHome />
      : activeRole.substr(0, 19) === 'Prodekan za nastavu' ?
                                  <StudentServiceHome />
      : activeRole.substr(0, 38) === 'Služba za nastavu i studentska pitanja' ?
                                      <EmploymentServiceCSHome />
      : activeRole.substr(0, 8) === 'Ministar' ?
                          <HomePage />
      : activeRole.substr(0, 4) === 'AIDA' ?
                                          <DefaultHomePage/>
      : activeRole.substr(0, 2) === 'HR' ?
                                              <DefaultHomePage/>
      :activeRole.substr(0, 40) === 'Služba za zapošljavanje Kantona Sarajevo' ? <EmploymentServiceCSHome />

      :activeRole.substr(0,14) === 'QA admin - OJ:' ? <DefaultHomePage />
      :activeRole.substr(0,30) === 'Služba za osiguranje kvaliteta' ? <DefaultHomePage />

      : null

    }
      </div>
    )
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js